/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ generated: NonNullable<unknown>, cached: NonNullable<unknown> }} Pre_Render_Frame_Cache_Complete_ToastInputs */

const en_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frame cache ready (${i?.generated} generated, ${i?.cached} already cached)`)
};

const fr_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cache d'images prêt (${i?.generated} générées, ${i?.cached} déjà en cache)`)
};

const de_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frame-Cache bereit (${i?.generated} generiert, ${i?.cached} bereits im Cache)`)
};

const it_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cache dei frame pronta (${i?.generated} generato, ${i?.cached} già memorizzato nella cache)`)
};

const ru_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Кэш кадров готов (${i?.generated} сгенерирован, ${i?.cached} уже кэширован)`)
};

const es_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caché de fotogramas lista (${i?.generated} generados, ${i?.cached} ya en caché)`)
};

const zh_cn2_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`帧缓存已就绪（${i?.generated} 已生成，${i?.cached} 已缓存）`)
};

const ja_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレームキャッシュ準備完了（${i?.generated}生成済み、${i?.cached}は既にキャッシュ済み）`)
};

const hi_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ्रेम कैश तैयार है (${i?.generated} जनरेट हो गया है, ${i?.cached} पहले से ही कैश में मौजूद है)`)
};

const pt_pt2_pre_render_frame_cache_complete_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cache de quadros pronto (${i?.generated} gerado, ${i?.cached} já em cache)`)
};

/**
* | output |
* | --- |
* | "Frame cache ready ({generated} generated, {cached} already cached)" |
*
* @param {Pre_Render_Frame_Cache_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_complete_toast = /** @type {((inputs: Pre_Render_Frame_Cache_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "de") return de_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "it") return it_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "ru") return ru_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "es") return es_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "ja") return ja_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "hi") return hi_pre_render_frame_cache_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_pre_render_frame_cache_complete_toast(inputs)
	return en_pre_render_frame_cache_complete_toast(inputs)
});